/**
 * Por dónde entra cada uno a Configuración (`/settings`, sin sección).
 *
 * Siempre fue «General». La vendedora del drop no tiene General (su portón la devuelve a Ventas), así que para ella la
 * entrada es Integraciones: lo primero que le toca ver, donde están sus couriers (founder, 26-oct-2026: «en el sidebar
 * de Configuración debe decir Integraciones, y como única integración Shalom… no crear ni recrear páginas»).
 */
import { Navigate } from 'react-router-dom';
import { useSoyVendedorDelDrop } from '@/hooks/useSoyVendedorDelDrop';

export function LaEntradaDeConfiguracion() {
  const vendedora = useSoyVendedorDelDrop();
  return <Navigate to={vendedora ? 'integrations' : 'general'} replace />;
}
